import { cartActions } from "../../Store/CartSlice";

const DecrementItems = (id, dispatch) => {
  return dispatch(cartActions?.decrementFromCart(id));
};

export const decrementItems = DecrementItems;
